import React from 'react';
import {Layout} from './layouts/Layout';

export function App() {
  return <Layout />;
}
